var $15cb995db4a65460$exports = {};
$15cb995db4a65460$exports = {
    "(optional)": `(opcional)`,
    "(required)": `(obrigat\xf3rio)`
};


export {$15cb995db4a65460$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
